export default __webpack_public_path__ + "static/media/gallery-38.83bde113.jpg";